import { createSlice } from '@reduxjs/toolkit';
import { getLanguage, setLanguage as persistLanguage } from '../utils/languageStorage';

// 초기 언어 상태 설정 (쿠키 우선 → localStorage → 'ko')
const initialState = {
  language:
    typeof window !== 'undefined' ? getLanguage() : 'ko',
};

// createSlice로 언어 상태 및 액션 정의
const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload;
      if (typeof window !== 'undefined') {
        persistLanguage(action.payload);
      }
      if (typeof document !== 'undefined' && document.documentElement) {
        document.documentElement.lang = action.payload === 'ko' ? 'ko' : 'en';
      }
    },
  },
});

// 액션 생성자와 리듀서 내보내기
export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
